import axios from 'axios'

const state = {
  lista: [],
  textoPesquisa: '',
  status: '1',
  idGrupo: null,
  registroSelecionadoId: null,
  recarregarLista: false
}

const mutations = {
  SET_LISTA (state, payload) {
    state.lista = payload
  },
  SET_TEXTO_PESQUISA (state, payload) {
    state.textoPesquisa = payload
  },
  SET_STATUS (state, payload) {
    state.status = payload
  },
  SET_ID_GRUPO (state, payload) {
    state.idGrupo = payload
  },
  SET_REGISTRO_SELECIONADO_ID (state, payload) {
    state.registroSelecionadoId = payload
  },
  SET_RECARREGAR_LISTA (state, payload) {
    state.recarregarLista = payload
  },
  SET_LIMPAR (state) {
    state.textoPesquisa = ''
    state.status = '1'
    state.idGrupo = null
  }
}

const actions = {
  GET_LISTA: async ({ commit, state }) => {
    try {
      const filtros = {
        textoPesquisa: state.textoPesquisa,
        status: state.status,
        idGrupo: state.idGrupo
      }

      const { data } = await axios.post('/api/protected/subgrupo/produto/pesquisar', filtros)
      commit('SET_LISTA', data)
      commit('SET_RECARREGAR_LISTA', false)
      return data
    } catch (error) {
      console.error('Erro ao buscar lista de subgrupos de produtos:', error)
      throw error
    }
  }
}

const getters = {
  lista: state => state.lista,
  textoPesquisa: state => state.textoPesquisa,
  status: state => state.status,
  idGrupo: state => state.idGrupo,
  registroSelecionadoId: state => state.registroSelecionadoId,
  recarregarLista: state => state.recarregarLista
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/subgrupo-produto-store.js